import { Box, Center, Heading, Image, Spacer, Stack } from "@chakra-ui/react";
import * as React from "react";

import { Creator } from "../api/creator";
import { rewriteCdnUrl } from "../lib/cdn";
import { Avatar } from "./avatar";
import { Toaster } from "./chakra/toaster";

interface CreatorShellProps {
  creator: Creator;
  children?: React.ReactNode;
}

export const CreatorShell = ({ creator, children }: CreatorShellProps) => {
  let avatarUrl = creator["avatar-url"];
  if (avatarUrl) {
    avatarUrl = rewriteCdnUrl(`${avatarUrl}-/format/auto/-/preview/240x240/`);
  }
  let bannerUrl = creator["banner-url"];
  if (bannerUrl) {
    bannerUrl = rewriteCdnUrl(`${bannerUrl}-/format/auto/-/preview/2400x600/`);
  }

  return (
    <Stack maxW="3xl" gap={2}>
      <Box
        bg={"gray.100"}
        borderBottomRadius="lg"
        w="full"
        h="150px"
        position="relative"
        mt={-8}
      >
        {bannerUrl && (
          <Image
            alt="Banner"
            borderBottomRadius="lg"
            h="100%"
            objectFit="cover"
            src={bannerUrl}
            w="full"
          />
        )}
      </Box>
      <Center>
        <Stack align="center" position="relative" mt="-64px">
          <Avatar
            shadow="lg"
            colorPalette="gray"
            name={creator.vanity}
            shape="rounded"
            size="2xl"
            src={avatarUrl as string}
          />
          <Heading size="xl">{creator.vanity}</Heading>
        </Stack>
      </Center>
      <Spacer />
      {children}
      <Toaster />
    </Stack>
  );
};
